import React, { useState } from "react";
import moment from "moment";
import __ from "lodash";
import Alert from "../../../controls/Alert";
import {validateEmail} from "../../../functions/EmailValidation";

const AddEnquiryValidator = (props) => {
  const record = props.record;
  const [state, setState] = useState({
    error: null,
    errorMessage: null,
    field: null,
  });

  const operatorName = __.startCase(__.toLower(process.env.REACT_APP_COMPANY)) || "Magma";

  let field = null;
  let error = false;
  let errorMessage = "";
  let id = null;

  if (!error && !record.companyName) {
    error = true;
    errorMessage = "'Company' name is required";
    id = "companyName";
  }
  if (!error && !record.contactName) {
    error = true;
    errorMessage = "'Submitted By' is required";
    id = "contactName";
  }
  if (!error && !record.contactEmail) {
    error = true;
    errorMessage = "'Email' is required";
    id = "contactEmail";
  }
  if (!error && record.contactEmail && !validateEmail(record.contactEmail)) {
    error = true;
    errorMessage = `${record.contactEmail} is not a valid email address`;
    id = "contactEmail";
  }
  if (!error && !record.cargoAvailability) {
    error = true;
    errorMessage = `'Delivery at ${operatorName} Departure Point' is required`;
    id = "cargoAvailability";
  }
  if (!error && (!record.cargo || !Array.isArray(record.cargo) || record.cargo.length < 1)) {
    error = true;
    errorMessage = "At least one consignment is required";
    id = "cargo";
  }

  if (error !== state.error || errorMessage !== state.errorMessage) {
    setState({ ...state, error, errorMessage, field });
    if (props.onChange) {
      props.onChange({ error, errorMessage, field });
    }
  }

  return (
    <Alert open={error} severity="error" message={errorMessage} id={id}/>
  );
}

export default AddEnquiryValidator;
